import { useFixerContent } from '../hooks/i18n/usePageContent.js'
import { FixerCard, FixerKicker, FixerSection, FixerSectionIntro } from './fixer-ui.js'

export function FixerProductionSection() {
  const c = useFixerContent()
  return (
    <FixerSection id="production">
      <div className="fixer-stack-xl">
        <FixerSectionIntro
          channel="report"
          kicker={c.productionLifecycle.number}
          title={c.productionLifecycle.title}
          copy={c.productionLifecycle.copy}
          titleId="fixer-production-heading"
        />
        <div className="fixer-production-grid" role="list">
          {c.productionLifecycle.columns.map(col => (
            <FixerCard key={col.phase} interactive role="listitem">
              <div className="fixer-stack-md">
                <FixerKicker channel="signal" active={false}>{col.phase}</FixerKicker>
                <h3 className="fixer-subheading">{col.title}</h3>
                <p className="fixer-body-sm">{col.description}</p>
              </div>
            </FixerCard>
          ))}
        </div>
      </div>
    </FixerSection>
  )
}
